export const isMobile = (width?: number) => (width || window.innerWidth) <= 750

export const isScreenSmaller1000 = (width?: number) => (width || window.innerWidth) <= 1000
